import React from 'react';
import {
  Heading,
  Text,
} from '@ayble-health/dashboard-components';
import { differenceInYears } from 'date-fns';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { formatDateInBrowserTZ } from './utils';

export const UserProfile = () => {
  const {
    state: { user },
  } = useDashboardPageState();

  if (!user) return null;

  const {
    birthdate,
    canceled,
    care_model,
    created_at,
    ethnicity,
    first_name,
    gender,
    healthie_id,
    last_name,
    sex,
    phone_number,
    address_city,
    address_state,
    address_street,
    address_zip,
    timezone,
  } = user;

  const age = differenceInYears(new Date(), new Date(birthdate));
  const ageString = birthdate ? `${age}, ` : '';
  const sexDisplay = sex.charAt(0);
  const sexString = sexDisplay ? `${sexDisplay}, ` : '';
  const ethnicityDisplay = ethnicity ? `${ethnicity} ` : '';
  const genderDisplay =
    gender === 'Male' || gender === 'Female'
      ? gender.charAt(0)
      : !!gender
      ? 'Other'
      : gender;
  const genderString = genderDisplay ? `(Identify: ${genderDisplay})` : '';

  const address =
    address_city || address_state || address_street || address_zip
      ? `${address_street || '--'} ${address_city || '--'}, ${
          address_state || '--'
        } ${address_zip || '--'}`
      : '--';

  return (
    <>
      <Heading
        color={'secondary.500'}
        fontSize={'2xl'}
        fontWeight={'normal'}
        mb={4}
        textAlign={'left'}
      >
        {first_name} {last_name}
      </Heading>

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        {ageString}
        {sexString}
        {ethnicityDisplay}
        {genderString}
      </Text>

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        DOB: {birthdate ?? '--'}
      </Text>

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        Phone: {phone_number ?? '--'}
      </Text>

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        Address: {address}
      </Text>

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        Timezone: {timezone ?? '--'}
      </Text>

      <br />

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        Member since {formatDateInBrowserTZ(created_at, 'MMM D Y')} (
        {care_model})
      </Text>

      {canceled && (
        <Text color={'orange.500'} fontSize="sm" fontWeight={'normal'}>
          Canceled: {formatDateInBrowserTZ(canceled, 'MMM D Y') ?? '--'}
        </Text>
      )}

      <Text color={'secondary.500'} fontSize="sm" fontWeight={'normal'}>
        Healthie ID: {healthie_id ?? '--'}
      </Text>
    </>
  );
};
